<template>
  <div class="text-center pt-[100px]">
    <Resource
      :src="getFeUrl('/youyan-platform/png/loading.png')"
      class="h-[130px]"
    ></Resource>
    <div>正在跳转至视频创作平台，请稍等</div>
  </div>
</template>
<script lang="ts" setup>
import { authThird, loginForWeb } from '~/api'
import { COOKIE_KEY } from '~/constants/config'

const route = useRoute()
const requestURL = useRequestURL()
const { setSession } = useChangeUser()

onMounted(async () => {
  if (route.query.auth_session) {
    const { auth_session } = route.query

    const { data } = await authThird({
      auth_session: auth_session as string,
    })

    if (data) {
      await setSession(data)
      location.replace(requestURL.origin + '/platform')
    }
  }
})
</script>
<style lang="scss" scoped></style>
